import { Switch as BaseUISwitch } from '@base-ui/react/switch';
import styles from './Switch.scss';

export const Switch = (props: BaseUISwitch.Root.Props) => (
  <BaseUISwitch.Root {...props} className={styles.switch}>
    <BaseUISwitch.Thumb className={styles.thumb} />
  </BaseUISwitch.Root>
);
